/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import _replace from "lodash/replace";
import _findKey from "lodash/findKey";
import { getCaseLink, getProductData } from "./productService";

class RedirectService {
  getApplicationStep = (applicationStatus, product) => {
    const applicationStatusSummary = getProductData(product.name, "summaryStatus");
    const formSteps = getProductData(product.name, "formSteps");
    const targetApplicationStatus =
      product.applicationStatus > applicationStatusSummary || !applicationStatus
        ? product.applicationStatus
        : applicationStatus;
    return getCaseLink(product) + "/antrag/" + formSteps[targetApplicationStatus].stepUrl;
  };

  getStatusByLocation = (location, product) => {
    const formSteps = getProductData(product.name, "formSteps");
    const stepUrl = _replace(location, getCaseLink(product) + "/antrag/", "");
    return parseInt(_findKey(formSteps, ["stepUrl", stepUrl]), 10);
  };

  getApplicationLocation = (product, pathname) => {
    return this.getApplicationStep(this.getStatusByLocation(pathname, product) || product.applicationStatus, product);
  };
}

export default new RedirectService();
